import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTFoot = styled.tfoot.withConfig({
  displayName: "TableFoot__StyledTFoot",
  componentId: "sc-11fx9lj-0"
})(({
  theme,
  $cssStyles
}) => {
  return Object.assign({}, theme.typography['body-125'], $cssStyles);
});
export const TableFoot = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    callbackProps,
    tokenProps,
    restProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledTFoot, Object.assign({}, domProps, callbackProps, restProps, {
    $cssStyles: cssStyles,
    children: children
  }));
};